import '../scss/mediaDetail.scss';
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import $ from 'jquery';
import Lazyload from 'lazyload';
import throttle from 'lodash/throttle';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import { getBrowerAppId, getUrlQuery, uuid } from './utils';
import 'swiper/css';
import {
  fetchContentListByType,
  fetchMediaInfoV2,
  fetchSiteJson,
} from '../apis/api';
import initNewsTemplate from './newsTemplate';
import initWxSdk from './wxSdk';
import YouMeng from './YouMeng';
import NanFang from './NanFang';

const contentEmptyImg = require('../assets/images/content-empty.png');
const contentLoadingImg = require('../assets/images/content-loading.png');

let appId = uuid();
let mediaId = '';
let siteId = '';

const mediaContentType = {
  picTxt: '11',
  video: '13,14',
  audio: '15',
  media: '13,14,15',
} as { [propName: string]: string };

const mediaContentPage = {
  picTxt: {
    pageNum: 1,
    isFinish: false,
  },
  video: {
    pageNum: 1,
    isFinish: false,
  },
  audio: {
    pageNum: 1,
    isFinish: false,
  },
  media: {
    pageNum: 1,
    isFinish: false,
  },
} as {
  [propName: string]: {
    pageNum: number;
    isFinish: boolean;
  };
};

Swiper.use([FreeMode]);
let columnSwiper: Swiper;
let contentSwiper: Swiper;
const initMediaColumns = () => {
  columnSwiper = new Swiper('#media-column-list', {
    slidesPerView: 'auto',
    freeMode: true,
    centerInsufficientSlides: true,
    breakpoints: {
      320: {
        spaceBetween: 15,
      },
      650: {
        spaceBetween: 20,
      },
    },
  });
  $('.media-column-item').on('click', (evt) => {
    const { index } = evt.currentTarget.dataset;
    contentSwiper.slideTo(Number(index));
    columnSwiper.slideTo(Number(index));
    $('.media-column-active').removeClass('media-column-active');
    $(evt.currentTarget)
      .find('.media-column-line')
      .addClass('media-column-active');
  });
};

const initMediaContents = () => {
  contentSwiper = new Swiper('#media-content-list', {
    on: {
      slideChange(swiper) {
        const { realIndex } = swiper;
        $('.media-column-active').removeClass('media-column-active');
        $($('.media-column-item')[realIndex])
          .find('.media-column-line')
          .addClass('media-column-active');
        columnSwiper.slideTo(realIndex);
      },
    },
  });
};

let isLoading = true;
const getMediaContentByCode = (code: string) => {
  if (mediaContentPage[code]) {
    const { pageNum, isFinish } = mediaContentPage[code];
    if (isFinish) {
      return;
    }
    fetchContentListByType(
      mediaId,
      appId,
      siteId,
      mediaContentType[code],
      mediaContentPage[code].pageNum,
      20,
      0,
    ).then((res) => {
      isLoading = false;
      mediaContentPage[code].isFinish =
        res.pageNum >= res.pages || !res.list.length;
      const contentId = `#content-${code.toLocaleLowerCase()}`;
      if (pageNum === 1 && res.list.length === 0) {
        $(contentId).addClass('media-content-empty');
        $(contentId).append(
          `<img src="${contentEmptyImg}" class="media-content-empty-image" alt="暂无内容">`,
        );
      }
      const loadingDom = $(contentId).find('.media-content-loading');
      if (loadingDom && loadingDom.length) {
        loadingDom.remove();
      }
      res.list.forEach((item) =>
        $(contentId).append(initNewsTemplate(item.data)),
      );
      const images = $(contentId).find('.t-news-image');
      const newImages = images.filter(
        (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
      );
      // eslint-disable-next-line no-new
      new Lazyload(newImages);
      const tVideos = $('.t-news-video');
      if (tVideos && tVideos.length) {
        tVideos.each((index, el) => {
          videojs(el, {
            aspectRatio: '16:9',
            controls: true,
            playbackRates: [0.75, 1, 1.25, 1.5, 2],
            poster: el.getAttribute('poster') || process.env.DEFAULT_IMAGE_16_9,
          });
        });
      }
    });
  }
};

const getMediaContent = (contentServiceCode: string[]) => {
  contentServiceCode.forEach((code) => getMediaContentByCode(code));
};

const initMediaContentsScroll = () => {
  $('.media-content-item').on(
    'scroll',
    throttle((evt) => {
      const { offsetHeight, scrollHeight, scrollTop } = evt.currentTarget;
      if (offsetHeight + scrollTop + 20 > scrollHeight) {
        const { code } = evt.currentTarget.dataset;
        const { isFinish } = mediaContentPage[code];
        if (isFinish) {
          return;
        }
        if (code && !isLoading) {
          $(evt.currentTarget).append(
            `<div class="media-content-loading"><img src="${contentLoadingImg}" class="media-content-loading-img" alt="正在加载..."></div>`,
          );
          $(evt.currentTarget).scrollTop(scrollTop + 40);
          isLoading = true;
          mediaContentPage[code].pageNum += 1;
          getMediaContentByCode(code);
        }
      }
    }, 250),
  );
};

const initMediaInfo = () => {
  return new Promise((resolve) => {
    if (mediaId && siteId) {
      fetchMediaInfoV2(mediaId, appId, siteId).then((res) => {
        if (Number(res.status) === 200) {
          const contentServiceCode: string[] = [];
          const columnHtmls: string[] = [];
          const contentHtmls: string[] = [];
          let showDesc = false;
          $('#media-avatar').attr('src', res.logo);
          $('#media-name').text(res.name);
          if (res.isShowFans) {
            $('#media-fans').text(`${res.followCount}粉丝`);
            $('#media-fans').show();
          }
          res.columnList.forEach((item, index) => {
            if (mediaContentType[item.serviceCode]) {
              contentServiceCode.push(item.serviceCode);
            }
            showDesc = showDesc || item.serviceCode === 'ABSTRACT';
            let lineHtml = '';
            if (index === 0) {
              lineHtml =
                '<div class="media-column-line media-column-active"></div>';
            } else {
              lineHtml = '<div class="media-column-line"></div>';
            }
            const nameHtml = `<span>${item.name}</span>`;
            const lowerServiceCode = item.serviceCode.toLocaleLowerCase();
            columnHtmls.push(
              `<div data-name="${lowerServiceCode}" data-index="${index}" class="swiper-slide media-column-item">${nameHtml}${lineHtml}</div>`,
            );
            contentHtmls.push(
              `<div data-code="${item.serviceCode}" id="content-${lowerServiceCode}" class="swiper-slide media-content-item"></div>`,
            );
          });
          $('#media-column-list')
            .find('.swiper-wrapper')
            .html(columnHtmls.join(''));
          $('#media-content-list')
            .find('.swiper-wrapper')
            .html(contentHtmls.join(''));
          if (showDesc && res.description) {
            $('#content-abstract').append(res.description);
          } else {
            $('#content-abstract').addClass('media-content-empty');
            $('#content-abstract').append(
              `<img src="${contentEmptyImg}" class="media-content-empty-image" alt="暂无内容">`,
            );
          }
          const temp = document.createElement('div');
          temp.innerHTML = res.description;
          const descText = temp.innerText;
          temp.remove();
          initWxSdk({
            wxShare: {
              title: `${res.name}作品集`,
              desc: descText || `${res.name}作品集`,
              imgUrl: (res.logo || process.env.DEFAULT_SHARE_IMAGE) as string,
            },
          });
          if ($('meta[property="og:title"]')) {
            $('meta[property="og:title"]')?.attr(
              'content',
              `${res.name}作品集`,
            );
          }
          if ($('meta[property="og:description"]')) {
            $('meta[property="og:description"]')?.attr(
              'content',
              descText || `${res.name}作品集`,
            );
          }
          if ($('meta[property="og:image"]')) {
            $('meta[property="og:image"]')?.attr(
              'content',
              res.logo || process.env.DEFAULT_SHARE_IMAGE || '',
            );
          }
          document.title = `${res.name}作品集`;
          initMediaColumns();
          initMediaContents();
          initMediaContentsScroll();
          getMediaContent(contentServiceCode);
          resolve(true);
        }
      });
    }
  });
};

const initSiteJson = () => {
  return new Promise((resolve) => {
    fetchSiteJson().then((res) => {
      $('.media-info-header')
        .find('a[name="download-link"]')
        .attr('data-href', res.downloadUrl);
      const bodyWidth = document.body.clientWidth;
      $('.media-info-header')
        .find('.launch-app-btn')
        .css('width', bodyWidth < 650 ? bodyWidth * 0.9 : 650 * 0.9);
      $('.media-info-header')
        .find('.media-info')
        .css('width', bodyWidth < 650 ? bodyWidth * 0.9 : 650 * 0.9);
      resolve(true);
    });
  });
};

(() => {
  const params = getUrlQuery();
  mediaId = params.mediaId;
  siteId = params.siteId;
  $('div[name="mediaId"]').text(mediaId);
  $('div[name="siteId"]').text(siteId);
  const domainArr = window.location.hostname.split('.');
  domainArr[0] = 'www';
  $('div[name="mainDomain"]').text(`https://${domainArr.join('.')}`);
  getBrowerAppId((browerId) => {
    appId = browerId;
    Promise.all([initMediaInfo(), initSiteJson()]).then(() => {
      initWxSdk({
        launchAppBtn: [
          {
            attr: 'class',
            value: 'media-info-header',
          },
        ],
      });
    });
  });
  YouMeng.initYoumeng();
  YouMeng.initYoumengLog(() => {
    YouMeng.pushRecord(
      { article_id: mediaId },
      'gzcmc.xhc.h5.manuscript.view.click',
      'onload',
    );
  });
  NanFang.init().then(() => {
    NanFang.openArticle(mediaId);
  });
})();
